import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

export const getFeeStructureDetails = createAsyncThunk(
  'getFeeStructureDetails/All',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/fee-structure/',
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const postFeeStructureDetails = createAsyncThunk(
  'postFeeStructureDetails/All',
  async (value, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/fee-structure/',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data: value,
      });
      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const postHomeWorkDetails = createAsyncThunk(
  'postHomeworkDetails/All',
  async (details, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/homework/',
        method: 'POST',
        data: details,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const updateHomeWorkDetails = createAsyncThunk(
  'updateHomeworkDetails/All',
  async (details, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/homework/',
        method: 'PUT',
        data: details,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const getHomeWorkDetails = createAsyncThunk(
  'getHomeworkDetails/All',
  async (details, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/homework/',
        method: 'GET',
        headers: details,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const deleteHomeWorkDetails = createAsyncThunk(
  'deleteHomeWorkDetails/All',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/homework/${id}`,
        method: 'DELETE',
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const postAnnouncementDetails = createAsyncThunk(
  'postAnnouncementDetails/All',
  async (details, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/announcements/',
        method: 'POST',
        data: details,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const updateAnnouncementDetails = createAsyncThunk(
  'updateAnnouncementDetails/All',
  async (details, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/announcements/',
        method: 'PUT',
        data: details,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const getAnnouncementDetails = createAsyncThunk(
  'getAnnouncementDetails/All',
  async (details, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/announcements/',
        method: 'GET',
        headers: details,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const deleteAnnouncementDetails = createAsyncThunk(
  'deleteAnnouncementDetails/All',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/announcements/${id}`,
        method: 'DELETE',
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue('error');
    }
  },
);
export const sendFeesNotificaitons = createAsyncThunk(
  'sendFeesNotificaitons',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/notification/send',
        method: 'POST',
      });

      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response?.status,
      });
    }
  },
);
const mobileSlice = createSlice({
  name: 'notifications',
  initialState: [],
  reducers: {},
});
export default mobileSlice.reducer;
